import React, { useEffect, useState } from "react";
import {
    Container, Row, Col, Input, Button,
    Card, CardHeader, CardBody, Table
} from "reactstrap";
import UploadDropzone from "../components/UploadDropzone";
import { Language, TranslateSharp, Assignment, InfoOutlined } from "@material-ui/icons";
import { useTranslateMutation } from "../hooks/useTranslateMutation";
import { useDocumentTranslateMutation } from "../hooks/useDocumentTranslateMutation";
import { useQueryParams } from '../hooks/useQueryParams';
import { useGetTranslation } from '../hooks/useGetTranslation';
import CustomPagination from '../components/CustomPagination';
import ShowTranslationResultModal from '../components/ShowTranslationResultModal';
import { toCustomDateTimeString } from '../utils/toCustomDateTimeString';
import { DateTime } from 'luxon';
import Toastr from "toastr";
import Select from "react-select";
import { copyTextToClipboard } from "../utils/copyToClipboard";
import { TRANSLATOR_LOCATIONS } from './../constants';

const RESULTS_PER_PAGE = 10;
const TranslatePage: React.FC = () => {
    const query = useQueryParams()
    const [translationInputFile, setTranslationInputFile] = useState<File>();
    const [uploadFile, setUploadFile] = useState<boolean>(false);
    const [fromTranslationText, setFromTranslationText] = useState<string>("");
    const [toTranslationText, setToTranslationText] = useState<string>("");
    const [modalText, setModalText] = useState<string>("");
    const [inputModalOpen, setInputModalOpen] = useState(false);
    const [fromLanguage, setFromLanguage] = useState<any>(null);
    const [toLanguage, setToLanguage] = useState<any>({ value: "en", label: "English" });

    const [pageTable, setPageTable] = useState(() => {
        let page = +(query.get('page') || 0)
        if (isNaN(page) || page <= 0) {
            return 1
        }
        return page
    })

    const {
        isError,
        isLoading,
        data,
        refetch,
    } = useGetTranslation(pageTable, RESULTS_PER_PAGE)

    useEffect(() => {
        refetch()
    }, [pageTable])

    const {
        mutate: translate,
        data: translationResponse,
        isLoading: translationLoading,
        isError: translationError,
    } = useTranslateMutation();


    const {
        mutate: translateDocument,
        data: documentTranslationResponse,
        isLoading: documentTranslationLoading,
        isError: documentTranslationError,
    } = useDocumentTranslateMutation();

    useEffect(() => {
        if (documentTranslationResponse) {
          Toastr.success(`Translation started for execution id ${documentTranslationResponse.jobId}`);
          setTranslationInputFile(undefined);
        }
      }, [documentTranslationResponse])

    useEffect(() => {
        if (documentTranslationError) {
            Toastr.error("Something bad happened.")
        }

    }, [documentTranslationError])


    useEffect(() => {
        if (translationError) {
            Toastr.error("Something bad happened.")
        }

    }, [translationError])

    useEffect(() => {
        if (translationResponse) {
            setToTranslationText(translationResponse.translation.output)
        }
    }, [translationResponse]);

    const handleTranslateDocumentSubmit = () => {
        if (uploadFile && !translationInputFile) {
            alert("Please upload a file.");
            return;
        }

        if (!toLanguage) {
            alert("Please select an output language.");
            return;
        }

        if (fromLanguage && toLanguage && fromLanguage.value === toLanguage.value) {
            alert("You can not translate same language, please select different language");
            return;
        }

        translateDocument({
            file: translationInputFile,
            fromLang: fromLanguage ? fromLanguage.value : null,
            toLang: toLanguage.value,
        })
    }

    const handleTranslateSubmit = () => {
        if (!uploadFile && !fromTranslationText) {
            alert("Please enter text to translate.");
            return;
        }

        if (!toLanguage) {
            alert("Please select an output language.");
            return;
        }

        if (fromLanguage && toLanguage && fromLanguage.value === toLanguage.value) {
            alert("You can not translate same language, please select different language");
            return;
        }

        translate({
            inputText: fromTranslationText,
            fromLang: fromLanguage ? fromLanguage.value : null,
            toLang: toLanguage.value,
        });
    }

    const languageOptions = TRANSLATOR_LOCATIONS;

    const makeModelOpen = (text: string) => {
        setModalText(text);
        setInputModalOpen(true);
    }

    const closeTranslationResultModel = () => {
        setInputModalOpen(false);
        setModalText("");
    }

    return (<>
        <div className="header pb-6 pt-5 pt-md-7"
            style={{
                height: "600px",
                backgroundColor: '#2D315C',
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundImage: "url(/background-header-infinity.jpg)"
            }}
        >
            {/* Mask */}
            <span className="mask bg-gradient-default opacity-8" />
            <Container style={{ display: "flex", flexDirection: "column" }} fluid>
                <div style={{ textAlign: "left", marginLeft: '10px', marginBottom: "10px" }}>
                    <Button
                        color="primary"
                        onClick={() => {
                            setUploadFile(false)
                            setFromTranslationText("")
                            setToTranslationText("")
                        }}
                        style={{
                            width: "auto",
                            fontSize: "20px",
                            background: uploadFile ? "rgb(82 255 249 / 9%)": "rgb(82 255 249 / 20%)",
                            border: "#FF5252",
                        }}
                        className="btn-sm "
                    >
                        <div style={{ display: 'flex' }}>
                            <TranslateSharp style={{ marginTop: '0px', marginRight: '10px', fontSize: '31px' }} />
                            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                                <div>
                                    <label style={{ color: "#fff", margin: 0, padding: 0 }}>Translate Text</label>
                                </div>
                                {/* <div style={{ fontSize: "14px", fontStyle: "italic", margin: 0, padding: 0 }}>
                                    <label style={{ color: "white" }}>130+ languages</label>
                                </div> */}

                            </div>
                        </div>

                    </Button>
                    <Button
                        color="primary"
                        onClick={() => {
                            setUploadFile(true)
                            setFromTranslationText("")
                            setToTranslationText("")
                        }}
                        style={{
                            width: "auto", fontSize: "20px", 
                            background: !uploadFile ? "rgb(82 255 249 / 9%)": "rgb(82 255 249 / 20%)",
                            border: "#FF5252"
                        }}
                        className="btn-sm "
                    >
                        <div style={{ display: 'flex' }}>
                            <Assignment style={{ marginTop: '0px', marginRight: '10px', fontSize: '31px' }} />
                            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                                <div>
                                    <label style={{ color: "#fff", margin: 0, padding: 0 }}>Translate File</label>
                                </div>
                                {/* <div style={{ fontSize: "14px", fontStyle: "italic", margin: 0, padding: 0 }}>
                                    <label style={{ color: "white" }}>.pdf, .docx, .pptx</label>
                                </div> */}

                            </div>
                        </div>
                    </Button>
                </div>
                <Row>
                    <Col>
                        <div style={{ textAlign: "center" }}>
                            {uploadFile ? (
                                <>
                                    <div style={{ display: "flex", width: "100%" }}>
                                        <div style={{ width: "50%", flex: 1 }}>
                                            <Select
                                                isClearable
                                                isSearchable
                                                value={fromLanguage}
                                                onChange={(selectedOption) => setFromLanguage(selectedOption)}
                                                options={languageOptions}
                                                placeholder="Select Language"
                                                styles={{ control: (styles) => ({ ...styles, fontSize: "20px", fontWeight: 600, borderRadius: '8px 0 0 0' }) }}
                                            />
                                        </div>
                                        <div style={{ width: "50%", flex: 1 }}>
                                            <Select
                                                isClearable
                                                isSearchable
                                                value={toLanguage}
                                                onChange={(selectedOption) => setToLanguage(selectedOption)}
                                                options={languageOptions}
                                                placeholder="Select To Language"
                                                styles={{ control: (styles) => ({ ...styles, fontSize: "20px", fontWeight: 600, borderRadius: '0 8px 0 0' }) }}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ width: "100%", marginBottom: '10px', borderRadius: '0 0 8px 8px' }}>
                                        <UploadDropzone
                                            setFile={setTranslationInputFile}
                                            isFileUploaded={!!translationLoading}
                                            accept={[
                                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                                'application/msword',
                                                'application/pdf',
                                                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                                                'application/vnd.ms-powerpoint'
                                            ]}
                                            icon="/icon-translation.svg"
                                            title="Click/drag and drop Doc/PDF/PPT file for translation."
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div style={{ display: "inline-block", width: "50%", marginBottom: '5px' }}>
                                        <div style={{ flex: 1 }}>
                                            <Select
                                                isClearable
                                                isSearchable
                                                value={fromLanguage}
                                                onChange={(selectedOption) => setFromLanguage(selectedOption)}
                                                options={languageOptions}
                                                placeholder="Select Language"
                                                styles={{ control: (styles) => ({ ...styles, fontSize: "20px", fontWeight: 600, borderRadius: '8px 0 0 0' }) }}
                                            />
                                        </div>
                                        <div style={{ position: 'relative' }}>
                                            <Input
                                                placeholder="Enter text to translate."
                                                type="textarea"
                                                name="text"
                                                id="exampleText"
                                                rows={10}
                                                value={fromTranslationText}
                                                onChange={(e) => setFromTranslationText(e.target.value)}
                                                style={{ borderRadius: '0 0 0 8px', resize: 'none', fontSize: '20px', color: 'unset' }}
                                            />
                                            {fromTranslationText && (
                                                <Button
                                                    className="clear-button"
                                                    size='md'
                                                    onClick={() => setFromTranslationText("")}
                                                    style={{ borderRadius: '0', position: 'absolute', top: '5px', right: '0px', padding: '0px', background: 'none' }}
                                                >
                                                    &#x2715;
                                                </Button>

                                            )}
                                            {fromTranslationText && (
                                                <Button
                                                    size='lg'
                                                    style={{ borderRadius: '0', position: 'absolute', bottom: '8px', right: '8px', padding: '0px', background: 'none' }}
                                                    onClick={() => copyTextToClipboard(fromTranslationText)}
                                                >
                                                    <i className='fas fa-copy'></i>
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                    <div style={{ display: "inline-block", width: "50%", marginBottom: '5px' }}>
                                        <div style={{ flex: 1 }}>
                                            <Select
                                                isClearable
                                                isSearchable
                                                value={toLanguage}
                                                onChange={(selectedOption) => {
                                                    setToLanguage(selectedOption)
                                                    setToTranslationText("")
                                                }}
                                                options={languageOptions}
                                                placeholder="Select Language"
                                                styles={{ control: (styles) => ({ ...styles, fontSize: "20px", fontWeight: 600, borderRadius: '0 8px 0 0' }) }}
                                            />
                                        </div>
                                        <div style={{ position: 'relative' }}>
                                            <Input placeholder="Translated Text"
                                                type="textarea"
                                                name="text"
                                                id="exampleText"
                                                rows={10}
                                                value={toTranslationText}
                                                onChange={(e) => setToTranslationText(e.target.value)}
                                                style={{ borderRadius: '0 0 8px 0', resize: 'none', fontSize: '20px', color: 'midnightblue' }}
                                            />
                                            {toTranslationText && (
                                                <Button
                                                    size='lg'
                                                    style={{ borderRadius: '0', position: 'absolute', bottom: '8px', right: '8px', padding: '0px', background: 'none' }}
                                                    onClick={() => copyTextToClipboard(toTranslationText)}
                                                >
                                                    <i className='fas fa-copy'></i>
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                </>
                            )
                            }
                        </div>
                        {!uploadFile ? (<div style={{ textAlign: "center" }}>
                            {
                                translationLoading ? (
                                    <svg height="70px" viewBox="0 0 187.3 93.7" preserveAspectRatio="xMidYMid meet" >
                                        <path stroke="rgb(215, 61, 50)" id="outline" fill="none" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
                                            d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z" />
                                        <path id="outline-bg" opacity="0.05" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
                                            d="				M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z" />
                                    </svg>
                                ) : (
                                    <>
                                        <Button
                                            color="primary"
                                            onClick={handleTranslateSubmit}
                                            disabled={translationLoading}
                                            style={{
                                                width: "auto",
                                                fontSize: "20px",
                                                background: "#FF5252",
                                                border: "#FF5252"
                                            }}
                                            className="btn-sm "
                                        >
                                            <div style={{ display: 'flex' }}>
                                                <Language style={{ marginTop: '4px', marginRight: '5px' }} />
                                                Translate
                                            </div>
                                        </Button>
                                    </>
                                )
                            }
                        </div>): (<div style={{ textAlign: "center" }}>
                            {!documentTranslationLoading ? (<Button
                                color="primary"
                                onClick={handleTranslateDocumentSubmit}
                                disabled={documentTranslationLoading}
                                style={{
                                    width: "auto",
                                    fontSize: "20px",
                                    background: "#FF5252",
                                    border: "#FF5252"
                                }}
                                className="btn-sm "
                            >
                                <div style={{ display: 'flex' }}>
                                    <Language style={{ marginTop: '4px', marginRight: '5px' }} />
                                    Translate Document
                                </div>
                            </Button>):(
                                <svg height="70px" viewBox="0 0 187.3 93.7" preserveAspectRatio="xMidYMid meet" >
                                    <path stroke="rgb(215, 61, 50)" id="outline" fill="none" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
                                        d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z" />
                                    <path id="outline-bg" opacity="0.05" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
                                        d="				M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z" />
                                </svg>
                            )}
                        </div>)}
                    </Col>
                </Row>
            </Container>
            {(data && data.data.length) && <Container className="mt--2" fluid>
                <Row className="mt-5">
                    <Col className="mb-5 mb-xl-0">
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <h3>Past Translations</h3>
                            </CardHeader>
                            <CardBody>
                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">
                                        <tr>
                                            <th>ID</th>
                                            <th>Status</th>
                                            <th>Executed By</th>
                                            <th>Executed At</th>
                                            <th>Input</th>
                                            <th>Output</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.data.map((record) => <tr key={record.id}>
                                            <td>{record.id}</td>
                                            <td>{record.status}
                                            {record.errorText && <div style={{ display: "inline-block" }} 
                                                title={record.errorText}>
                                                <InfoOutlined style={{ color: 'red', marginLeft: '10px', cursor: 'pointer' }} />
                                            </div>}
                                            </td>
                                            <td>{record.createdBy}</td>
                                            <td>{record.createdAt ? toCustomDateTimeString(DateTime.fromISO(record.createdAt)) : 'NA'}</td>
                                            <td>
                                                {record.inputType === 'text' ? (<a href="#0" onClick={() => makeModelOpen(record.input)}>
                                                    <i className="fas fa-eye"></i>
                                                </a>): (
                                                    <a href={`${record.input}?token=${localStorage.getItem('token')}`} download target='_blank' rel='noreferrer'><i className="fas fa-download"></i></a>
                                                )}
                                            </td>
                                            <td>
                                                {record.inputType === 'text' ? (<a href="#0" onClick={() => makeModelOpen(record.output)}>
                                                    <i className="fas fa-eye"></i>
                                                </a>): (
                                                    <>
                                                        {(record.output) && <a href={`${record.output}?token=${localStorage.getItem('token')}`} download target='_blank' rel='noreferrer'><i className="fas fa-download"></i></a>}
                                                    </>
                                                )}
                                            </td>
                                        </tr>)}
                                    </tbody>
                                    <tfoot>
                                        <nav style={{ display: "inline-block" }} aria-label="...">
                                            <CustomPagination
                                                activePage={pageTable}
                                                totalResults={data.total}
                                                resultsPerPage={RESULTS_PER_PAGE}
                                                onChange={setPageTable}
                                                label="Table navigation"
                                            />
                                        </nav>
                                    </tfoot>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>}
        </div>
        <ShowTranslationResultModal text={modalText} open={inputModalOpen} onClose={() => closeTranslationResultModel()} />
    </>)
}

export default TranslatePage;